import { FollowUpTypeDto } from 'src/generated-sources/openapi/wallet-service/tracking-registry';

interface IFollowUpTimeOption {
  value: FollowUpTypeDto;
  label: string;
}

export const followUpTimeOptions: IFollowUpTimeOption[] = [
  { value: 0, label: 'Indeterminado' },
  { value: 3, label: '3 meses' },
  { value: 4, label: '4 meses' },
  { value: 5, label: '5 meses' },
  { value: 6, label: '6 meses' },
  { value: 12, label: '12 meses' },
];

export const MAX_PAGE_SIZE = 9999999;
export const NO_NAME = $localize`:@@nameUnavailable:NOMBRE NO DISPONIBLE`;
